class ICoreReveal {
    observer = null;

    constructor() {
        const elements = document.querySelectorAll('.icore-reveal:not(.is-visible)');

        if (!elements.length) {
            return;
        }

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            elements.forEach((el) => el.classList.add('is-visible'));
            return;
        }

        this.observer = new IntersectionObserver(
            (entries) => entries.forEach((entry) => this.#onIntersect(entry)),
            { threshold: 0.12 }
        );

        elements.forEach((el) => this.observer.observe(el));
    }

    #onIntersect(entry) {
        if (!entry.isIntersecting) {
            return;
        }

        entry.target.classList.add('is-visible');
        this.observer.unobserve(entry.target);
    }

    destroy() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }
}

export default ICoreReveal;
